import { AxiosRequestConfig } from 'axios';
import parser from 'ua-parser-js';
import { isServer } from './is-server';

export const LOCALE_HEADER = 'X-Language';
export const PLATFORM_HEADER = 'X-User-Platform';
export const USER_AGENT_HEADER = 'User-Agent';
export const ACTIVITY_ID_HEADER = 'X-Activity-Id';
export const X_FORWARDED_FOR_HEADER = 'x-forwarded-for';
export const X_AZURE_CLIENTIP_HEADER = 'x-azure-clientip';
export const GUEST_COUNTRY_CODE_HEADER = 'X-Guest-Country-Code';
export const X_BOOKING_AID_HEADER = 'X-Booking-Aid';
export const X_BOOKING_LABEL_HEADER = 'X-Booking-Label';
export const DEFAULT_AFFILIATE_ID = '2412782';
export const DEFAULT_AFFILIATE_LABEL = '';

export interface CreateAxiosConfigParams {
  locale: string;
  activityId: string;
  origin?: string;
  userAgent?: string;
  guestCountryCode?: string;
  referer?: string;
}

export type CreateAxiosConfig = (
  params: CreateAxiosConfigParams
) => AxiosRequestConfig;

export const createAxiosConfig: CreateAxiosConfig = ({
  locale,
  activityId,
  userAgent: userAgentOverride,
  guestCountryCode,
  referer,
  origin,
}) => {
  const clientUserAgent = !isServer() ? navigator.userAgent : undefined;
  const userAgent = userAgentOverride ?? clientUserAgent;
  const platform = getPlatform(userAgent);

  const url = isServer() ? referer : window.location.href;
  const searchParams = new URLSearchParams((url ?? '').split('?')[1]);
  const aid = searchParams.get('aid') ?? DEFAULT_AFFILIATE_ID;
  const label = searchParams.get('aid_label') ?? DEFAULT_AFFILIATE_LABEL;

  return {
    headers: {
      [LOCALE_HEADER]: locale?.toLowerCase() ?? '',
      [PLATFORM_HEADER]: platform,
      [ACTIVITY_ID_HEADER]: activityId,
      [X_BOOKING_AID_HEADER]: aid,
      [X_BOOKING_LABEL_HEADER]: label,
      ...(userAgentOverride && { [USER_AGENT_HEADER]: userAgentOverride }),
      ...(guestCountryCode && {
        [GUEST_COUNTRY_CODE_HEADER]: guestCountryCode,
      }),
    },
    baseURL: `${origin ?? ''}${process.env.NEXT_PUBLIC_API_BASE_PATH ?? ''}`,
  };
};

const getPlatform = (userAgent?: string): 'mobile' | 'desktop' => {
  const deviceType = parser(userAgent).device.type;
  return deviceType === 'mobile' ? 'mobile' : 'desktop';
};
